import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Breadcrumb bar for the Hardcoded Credentials section.
 *
 * Usage:
 *   <CredScanBreadcrumb current="Findings" />
 *   <CredScanBreadcrumb current="Scan Configurations" />
 *   <CredScanBreadcrumb current="Scan History" />
 *   <CredScanBreadcrumb current="Git Connections" />
 *   Omit `current` (or pass null) on the main dashboard page.
 */
const CredScanBreadcrumb = ({ current }) => {
  const { t } = useTranslation();
  return (
    <div className="px-3 pt-2 pb-1">
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ fontSize: 13 }}
      >
        {current ? (
          <NavLink
            to="/dashboard/discovery/hardcoded-credentials"
            style={{ textDecoration: "none", color: "#5177ff" }}
          >
            {t("credentialScanning.title")}
          </NavLink>
        ) : (
          <Typography sx={{ fontSize: 13, color: "text.primary" }}>
            {t("credentialScanning.title")}
          </Typography>
        )}

        {current && (
          <Typography sx={{ fontSize: 13, color: "text.primary" }}>
            {current}
          </Typography>
        )}
      </Breadcrumbs>
    </div>
  );
};

export default CredScanBreadcrumb;
